import { useRevalidator } from 'react-router';
import { useCallback, useMemo } from 'react';

export const useDataRefresh = () => {
    const { revalidate, state } = useRevalidator();

    const refresh = useCallback(() => {
        revalidate();
    }, [revalidate]);

    return useMemo(() => {
        return { refresh, state };
    }, [refresh, state]);
};
